import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        accountId: '',
        invoiceEnable: '',
        token: '',
        name: '',
        login: '',
        language: '',
        dateFormat: 0,
        role: 0,
        encoderStatus: '',
        encoderName: '',
        result: {},
        keyeeprom: '',
        callboard: {
            count: 0,
        }
    },
    mutations: {
        SET_ACCOUNTID: (state, accountId) => {
            state.accountId = accountId;
        },
        SET_INVOICEENABLE: (state, invoiceEnable) => {
            state.invoiceEnable = invoiceEnable;
        },
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_NAME: (state, name) => {
            state.name = name;
        },
        SET_LOGIN: (state, login) => {
            state.login = login;
        },
        SET_LANGUAGE: (state, language) => {
            state.language = language;
        },
        SET_DATEFORMAT: (state, dateFormat) => {
            state.dateFormat = dateFormat;
        },
        SET_ROLE: (state, role) => {
            state.role = role;
        },
        SET_ENCODERSTATUS: (state, status) => {
            state.encoderStatus = status;
        },
        SET_ENCODERNAME: (state, name) => {
            state.encoderName = name;
        },
        SET_RESULT: (state, result) => {
            state.result = result;
        },
        SET_KEYEEPROM: (state, data) => {
            state.keyeeprom = data;
        },
        SET_CALLBOARD: (state, callboard) => {
            state.callboard = callboard;
        },
    }
    
});

export default store;



// WEBPACK FOOTER //
// ./src/views/store/index.js